<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'Kununu',
    computed: {
      ...mapState('kununu', ['kununu']),
    },
    created() {
      this.getKununu()
    },
    methods: {
      ...mapActions('kununu', ['getKununu']),
    },
  }
</script>
